import { X } from 'lucide-react';
import { Search } from '../search';

interface MobileSearchOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileSearchOverlay({ isOpen, onClose }: MobileSearchOverlayProps) {
  return (
    <div
      className={`fixed inset-0 z-[60] bg-[#081021]/45 backdrop-blur-[2px] transition-all duration-300 ease-out lg:hidden ${isOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
        }`}
      onClick={onClose}
    >
      <div
        className={`absolute left-0 right-0 top-0 border-b border-[#E2E8F0] bg-[#FFFFFF] px-[1.6rem] pb-[1.6rem] pt-[calc(env(safe-area-inset-top)+1.6rem)] shadow-[0_8px_24px_0_rgba(0,0,0,0.12)] transition-all duration-300 ease-out dark:border-primary dark:bg-[#091327] ${isOpen ? 'translate-y-0 opacity-100' : 'translate-y-[-1.6rem] opacity-0'
          }`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center gap-[1rem]">
          <Search
            variant="header"
            placeholder="Type to search..."
            autoFocus={isOpen}
            className="max-w-none flex-1"
          />

          <button
            type="button"
            onClick={onClose}
            className="flex h-[4rem] w-[4rem] shrink-0 items-center justify-center rounded-full bg-[#F4F7FE] text-[#7988A4] transition-colors duration-200 hover:bg-[#E8F3FF] hover:text-[#1C37E0] dark:bg-[#17233A] dark:text-[#9FB0D0] dark:hover:bg-[#1F2D45] dark:hover:text-[#7EA2FF]"
            aria-label="Close search"
          >
            <X size={22} />
          </button>
        </div>
      </div>
    </div>
  );
}
